import React, { useState, useEffect, Fragment } from "react";
import LeadDetailsApt from "components/sales/formSection/leadDetails/leadDetailsApt";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/locationOnboarding";
import CategoryDetails from "components/sales/formSection/categoryDetails/categoryDetails";
import CategoryDetailsCorp from 'components/sales/formSection/categoryDetails/categoryDetailsCorp';
import LeadDetailsSupply from "components/sales/formSection/leadDetails/leadDetailsSupply";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import BulkUpload from "components/sales/bulkUpload/bulkUpload";
import LeadDetails from 'components/sales/formSection/leadDetails/leadDetails';
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import Layout from 'components/sales/layout/layout';
import './form.css';
import { toast } from "react-toastify";
import Regex from "services/utils/regex/Regex";
const FinanceBusinessOnbaording = ({
                        locationCity,
                        cities,
                        locationZone,
                        zones,
                        locationArea,
                        areas,
                        locationType,
                        locTypesData,
                        locationState,
                        createApartmentLead,
                        locationPinCode,
                        pincodeData,
                        rwaTenureFun,
                        rwaTenureData,
                        appartmentDropDown,
                        getApartmentDropDown,
                        getCurrentLocation,
                        latlng,
                        toastMsg,
                        BulkUploadLead,
                        getSampleFileLead,
                        sampleData,
                        projectType,
                        projectSubType,
                        project_name,
                        lat,
                        lng,
                        corDropDownData,
                        financeProjectOnboarding,
                        splNameData,
                        supplyNameFun,
                        supDropDownData,
                        documentUploadUrl,
                        documentUrlData,
                        pocSubSiteTypeData,
                        pocSubSiteType,
                        currentLocation,
                        postApartmentData,
                        clientBillingAddress,
                        clientBillingPocData,
                        setIsLoading,
                        isPanRequired=false
                    }) => {
    const corporateInput = {
        leadDetails: null,
        pocDetails: null,
        location: null,
        categoryDetails: null,
        gateDetails: null,
        clientData: null
    };
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [corporateData, setCorporateData] = useState(corporateInput);
    const [isFiled, setIsFiled] = useState(false);
    const [isbulk, setIsbulk] = useState(false);
    const [isUploaded, setIsuploaded] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    // const [isLoading, setIsLoading] = useState(false);
    const [isDefalut, setIsDefalut] = useState(false);
    const [isSupply, setIsSupply] = useState(false);
    const [isApt, setIsApt] = useState(false);
    const [dropdown, setDropDown] = useState();
    

    useEffect(() => {
        if (appartmentDropDown) {
            setDropDown(appartmentDropDown);
        }
    }, [appartmentDropDown]);

    useEffect(() => {
        if(projectType == 1){
            setIsSupply(false);
            setIsApt(false);
        }else if (projectType == 2){
            setIsSupply(false);
            setIsApt(true);
        }else{
            setIsSupply(true);
            setIsApt(false);
        }
    },[projectType])

    const handleLeadSubmit = (val) => {
        setCorporateData({ ...corporateData, leadDetails: val });
        setIsDefalut(false);
    };
    const handlePocSubmit = (val) => {
        setCorporateData({ ...corporateData, pocDetails: val });
        setIsDefalut(false);
    };
    const handleLocSubmit = (val) => {
        setCorporateData({ ...corporateData, location: val });
        setIsDefalut(false);
    };
    const handleCatSubmit = (val) => {
        setCorporateData({ ...corporateData, categoryDetails: val });
        setIsDefalut(false);
    };
    const handleGatesSubmit = (val) => {
        setCorporateData({ ...corporateData, gateDetails: val });
        setIsDefalut(false);
    };

    const handleClientData = (val) => {
        setCorporateData({ ...corporateData, clientData: val });
    };

    const handleModalHide = async () => {
        setCorporateData(corporateInput);
        await getApartmentDropDown();
        setIsDefalut(true);
        setIsModal(false);
    };

    useEffect(() => {
        (async()=>{
            await getSampleFileLead();
        })();
    }, [getSampleFileLead])

    const handleSubmit = () => {
        //return false;
        const {
            leadDetails,
            pocDetails,
            location,
            categoryDetails,
            gateDetails,
            clientData
        } = corporateData;
        console.log('dd' + corporateData);
        if (
            leadDetails === null ||
            location === null ||
            pocDetails === null ||
            clientData === null ||
            (clientData.client_billing_value === 'Other' && (!clientData.billing_address || Object.keys(clientData.billing_address).length === 0))
            // categoryDetails === null
        ) { 
            setIsFiled(true);
            setIsModal(false);
            setIsFiled(true);
            const active = document.querySelector('.activeAnkInput');
            if(active){
                active.focus();
            }else{
                toast.error('Please Upload missed documents or enter valid data!')
            }
            return false;
        } 
        let clientValidator = true;
        if(clientData.pan_required === ''){
            toast.error('PAN selection is required!')
            return false;
        }
        if(clientData.pan_required==true && (clientData?.panNumber === '' || clientData?.panNumber === undefined || clientData?.panNumber === null)){
            toast.error('PAN number is required!')
            return false;
          }
          if(clientData.pan_required == true && (clientData?.panNumber === '' || clientData?.panNumber === undefined || clientData?.panNumber === null)){
            toast.error('PAN number is required!')
            return false;
          }
          if(clientData.client_gst && clientData.client_gst !== '' && clientData.client_gst !== null && Regex.gstRegex.test(clientData.client_gst) === false){
            toast.error('Invalid GST number. GSTIN must be 15 characters long and match the format: 11AAAAA1111A1Z1.');
            return false;
          }
          if(clientData?.client_type === 'existing_client' && (clientData?.client_id == "" || (clientData?.client_billing_id == "" && clientData?.billing_address == null))) {
            clientValidator = false;
          }
        
          if(clientData.poc_data) {
            const poc = clientData.poc_data;
             if(poc.pocName == "" || poc.pocDesVal == "" || poc.number == "" || poc.email == "") {
              clientValidator = false;
             }
          }else if(!clientData.client_poc_id || clientData.client_poc_id === ""){
            clientValidator = false;
          }
          if(clientData?.client_type === 'new_client') {
            const billAddress = clientData.billing_address; 
            if(!billAddress){
              clientValidator = false;
            }else{
              if(clientData?.client_name == "" || billAddress?.billPinId == "" || billAddress?.billGeoCityId == "" || billAddress?.billGeoStateId == "" || billAddress?.billAddressLine1 == "") {
                clientValidator = false;
                clientData.client_id=''
                clientData.client_billing_id=''
                clientData.client_billing_value=''
                clientData.client_poc_id=''
                clientData.client_poc_value=''
              }
            }   
        }
          if(clientValidator === false){
            console.log('clientvalidator', clientValidator);
            setIsFiled(true);
            setIsModal(false);
            setIsFiled(true);
            const active = document.querySelector('.activeAnkInput');
            if(active){
                active.focus();
            }else{
                toast.error('Please Upload missed documents or enter valid data!')
            }
            return false;
          }
        // else if(clientData?.client_pan===null ||
        //       clientData?.client_pan==undefined || 
        //       clientData?.client_pan=='' ){
        //     toast.error(localization?.panMandatory)
        //     setIsFiled(true);
        //     setIsModal(false);
        //     return false;
        // }
        else { 

            setIsFiled(false);
            (async () => {
                setIsLoading(true);
                const res = await financeProjectOnboarding({
                    ...leadDetails,
                    ...pocDetails,
                    ...location,
                    ...categoryDetails,
                    ...gateDetails,
                    ...clientData,
                    clientData,
                    projectType,
                    projectSubType,
                    project_name,
                    lat,
                    lng,
                    currentLocation
                });
                setIsLoading(false);
                localStorage.removeItem("currentLocation");
                if (res) {
                    setIsModal(true);
                }
            })();
        }
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getApartmentDropDown();
            setIsLoading(false);
        })();
    }, [getApartmentDropDown]);

    const handlebulkSubmit = async () => {
        if (bulkFile !== null) {
            const res = await BulkUploadLead(bulkFile);
            if (res) {
                setIsuploaded(true);
            } else {
                setIsuploaded(false);
            }
        }
    };
    const handleFileChange = (val) => setBulkFile(val);

    const headerBtns = () => {
        return (
            <Fragment>
                <Button onClick={() => setIsbulk(true)} className="btn btn-transparent">
                    {localization.bulkUpload}
                </Button>
            </Fragment>
        );
    };

    return (
          
        <>
        { projectType == 2  ? 
            <LeadDetailsApt
                inputLabel={localization.clientAprtname}
                handleValue={handleLeadSubmit}
                isApartment={true}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
                client_name={project_name}
                documentUploadUrl={documentUploadUrl}
            />
            :null}
            {projectType == 1  ? 
                <LeadDetails
                inputLabel={localization.clientName}
                isCorporate={true}
                corDropDownData={corDropDownData}
                handleValue={handleLeadSubmit}
                isDefalut={isDefalut}
                client_name={project_name}
            />
            :null}
            {projectType == 4 ?  
             <LeadDetailsSupply
                    inputLabel={localization.clientName}
                    isSupply={true}
                    handleValue={handleLeadSubmit}
                    pocSubSiteTypeData={pocSubSiteTypeData}
                    pocSubSiteType={pocSubSiteType}
                    supDropDownData={supDropDownData}
                    isDefalut={isDefalut}
                    client_name={project_name}
                    documentUploadUrl={documentUploadUrl}
                />
                :null}
                {/* {projectType == 1 ? 
            <LeadDetails
                inputLabel={localization.clientName}
                isCorporate={true}
                corDropDownData={corDropDownData}
                handleValue={handleLeadSubmit}
                isDefalut={isDefalut}
            /> : null } */}
            <PocDetails
                handleValue={handlePocSubmit}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
                projectType={projectType}
            />
            <Location
                locationCity={locationCity}
                cities={cities}
                locationZone={locationZone}
                zones={zones}
                locationArea={locationArea}
                areas={areas}
                locationType={locationType}
                locTypesData={locTypesData}
                handleValue={handleLocSubmit}
                locationState={locationState}
                locationPinCode={locationPinCode}
                pincodeData={pincodeData}
                getCurrentLocation={getCurrentLocation}
                latlng={latlng}
                toastMsg={toastMsg}
                isDefalut={isDefalut}
                lat={lat}
                lng={lng}
                currentLocation={currentLocation}
            />
            {/* {projectType == 2 ? 
                <CategoryDetails
                isApartments={isApt}
                isSupply={isSupply}
                handleValue={handleCatSubmit}
                corDropDownData={corDropDownData}
                rwaTenureFun={rwaTenureFun}
                rwaTenureData={rwaTenureData}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
            />: null
            } */}
            
            {/* {projectType === 1 ? 
                <CategoryDetailsCorp
                isSupply={false}
                handleValue={handleCatSubmit}
                supplyNameFun={supplyNameFun}
                splNameData={splNameData}
                rwaTenureFun={rwaTenureFun}
                rwaTenureData={rwaTenureData}
                corDropDownData={corDropDownData}
                isDefalut={isDefalut}
                />
                :null} */}

           
                {/* {projectType === 4 && projectSubType !== 9 && projectSubType !== 4 ? 
                            <CategoryDetails
                                    isSupply={true}
                                    supDropDownData={supDropDownData}
                                    handleValue={handleCatSubmit}
                                    isDefalut={isDefalut}
                                    projectSubType={projectSubType}
                                    documentUploadUrl={documentUploadUrl}
                                    documentUrlData={documentUrlData}
                                />
                                :null
                } */}

            
            <ClientDetails
              handleValue={handleClientData}
              locationPinCode={locationPinCode}
              pincodeData={pincodeData}
              data={postApartmentData}
              clientBillingAddress={clientBillingAddress}
              clientBillingPocData={clientBillingPocData}
              isPocShow={false}
              isGstShow={true}
              setIsLoading={setIsLoading}
              isPanRequired={isPanRequired}
            />    


            {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        isDefalut={isDefalut}
      /> */}
            <Fragment>
                <div className="btn-group">
                    <Button
                        onClick={handleSubmit}
                        className=""
                    >
                        <div className="">
                            {localization.submitDtl}
                        </div>
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                </div>
            </Fragment>

            <BulkUpload
                sampleData={sampleData && sampleData}
                handleModalHide={() => setIsbulk(!isbulk)}
                handlebulkSubmit={handlebulkSubmit}
                isbulk={isbulk}
                handleFileChange={handleFileChange}
                isUploaded={isUploaded}
            />
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{localization.leadSuccess}</h5>
                    <Link
                        to={`${baseUrl}/finance-business-list`}
                        className="btn btn-primary mb-4"
                    >
                       Project List <img src={Images?.ArrowRight} alt="" />
                    </Link>
                    {/* <Button onClick={handleModalHide} className="btn btn-transparent">
                        {localization.createAnother}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button> */}
                </div>
            </ModalPop>
        </>
    );
};

export default FinanceBusinessOnbaording;
